export default "__VITE_ASSET__DHhS_Rxx__"